<template>
  <div class="credit-widgets multi-widget-layout">
    <component
      :is="widget.component"
      v-for="(widget, index) in widgets"
      :key="index"
      :widget-data="widget.props?.widgetData"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import CashflowInsights from '@/V2/credit/widgets/CashflowInsights';
import ExpenditureInsights from '@/V2/credit/widgets/ExpenditureInsights';
import LoanInsights from '@/V2/credit/widgets/LoanInsights';
import RiskInsights from '@/V2/credit/widgets/RiskInsights';
import IncomeBusiness from '@/V2/credit/widgets/IncomeBusiness';
import IncomePersonal from '@/V2/credit/widgets/IncomePersonal';

export default {
  name: 'CreditWidgets',
  components: {
    CashflowInsights,
    ExpenditureInsights,
    LoanInsights,
    IncomeBusiness,
    IncomePersonal,
    RiskInsights,
  },
  computed: {
    ...mapState({
      credit: 'credit',
    }),
    incomeBusiness() {
      return this.credit?.customerIncome?.revenue;
    },
    incomePersonal() {
      return this.credit?.customerIncome?.personal_income;
    },
    widgets() {
      return [
        {
          component: IncomeBusiness,
          props: {
            widgetData: this.incomeBusiness,
          },
        },
        {
          component: LoanInsights,
        },
        {
          component: IncomePersonal,
          props: {
            widgetData: this.incomePersonal,
          },
        },
        {
          component: ExpenditureInsights,
        },
        {
          component: CashflowInsights,
        },
        {
          component: RiskInsights,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.multi-widget-layout {
  margin-top: 48px;
  display: flex;
  flex-wrap: wrap;
  gap: 36px 2%;
}
</style>
